<template>
  <div>
    <AccountantMenu v-if="isAccountant" />
    <ClientMenu v-else />
    <div class="container-fluid">
      <slot/>
    </div>
    <Footer/>
  </div>
</template>
<script>
import ClientMenu from './Menu.vue';
import AccountantMenu from '../../accountant/public/Menu.vue';
import Footer from './Footer.vue';

export default {
  name: 'Content',
  components: {
    ClientMenu,
    AccountantMenu,
    Footer
  },
  props: {
    isAccountant: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  }
};
</script>

<style type="text/css">
.container {
	margin-top: 20px;
	color: #7e7e7e;
	height: -webkit-fill-available;
	margin-right: auto;
	margin-left: auto;
	padding-left: 45px;
	padding-right: 15px;
	height: auto!important;
}
.md-title{
	color: #6d747c;
	font-weight: 400!important;
	font-family:Lato, sans-serif;
	font-size:12px;
}
.md-table-cell {
	height: 40px;
	position: relative;
	transition: .3s cubic-bezier(.4,0,.2,1);
	font-size: 12px;
	font-family: Lato,sans-serif;
	color: #7e7e7e;
}

</style>



// WEBPACK FOOTER //
// src/client/public/Content.vue